export default __webpack_public_path__ + "locales/lo-LA/ChangeUserStatusDialog.json?hash=af414490873763140929d56de0cd62a0";